

(async () => {
  import('./bootstrap.js');
})();
